import { autoMount } from '../../../utils/autoMount';
import { CompanyDetail } from '../../../components/pages/companyDetail';

autoMount({ CompanyDetail });
